if (!customElements.get('omnisend-form')) {
  class OmnisendForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.submitBtn = this.form?.querySelector('[type="submit"]');
      if (!this.submitBtn) return;

      this.email;
      this.fullName;
      this.phone;

      this.init();
    }

    init() {
      this.submitBtn.addEventListener("click", (e) => this.handleClick(e));
    }

    async handleClick(e) {
      this.email = this.form.querySelector('[name="contact[email]"]')?.value;
      this.fullName = this.form.querySelector('[name="contact[name]"]')?.value;
      this.phone = this.form.querySelector('[name="contact[phone]"]')?.value;

      e.preventDefault();
      const validation = this.validation();

      if (!validation) return;

      e.preventDefault();

      const fullNameArr = this.fullName.split(" ");
      const lastName = fullNameArr.length !== 1 ? fullNameArr[fullNameArr.length - 1] : "";
      const firstName = this.fullName.split(` ${lastName}`)[0];

      let data = {
        identifiers: [
          {
            channels: {
              email: {
                status: "subscribed",
                statusDate: new Date().toISOString(),
              },
            },
            id: this.email,
            type: "email",
          },
        ],
        firstName: firstName,
        lastName: lastName,
      };

      if (this.phone) {
        data.identifiers.push({
          channels: {
            sms: {
              status: "subscribed",
              statusDate: new Date().toISOString(),
            },
          },
          id: this.phone,
          type: "phone",
        });
      }

      await this.postContact(data);

      this.form.submit();
    }

    validation() {
      const validateEmail = this.emailValidator(this.email);
      const requiredInputArr = Array.from(this.form.querySelectorAll('[required]'));
      const requiredValueArr = requiredInputArr.map(obj => Boolean(obj.value));

      return Boolean(validateEmail && !requiredValueArr.includes(false));
    }

    async postContact(data) {
      if (!data) return;

      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-API-KEY":
            "6061103499f0b705daab3016-CjNYz0M5WnEOFRu1M9a9eoOC6eI3L34tPWWQDSfLq0095j0sAB",
        },
        body: JSON.stringify(data),
      };

      await fetch("https://api.omnisend.com/v3/contacts", options)
        .then((response) => response.json())
        .then((response) => console.log(response))
        .catch((err) => console.error(err));
    }

    emailValidator(str) {
      if (!str) return false;

      const emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return emailRegex.test(str);
    }
  }

  customElements.define("omnisend-form", OmnisendForm);
}
